export default "__VITE_ASSET__THlnvlVs__"